<router-outlet></router-outlet>
<ng-http-loader></ng-http-loader>
<redirector></redirector>
